<template>
    <div>
        <field-name :recipientInfo="recipientInfo" v-if="recipientInfo.name" />
        <textField
          v-if="recipientInfo.branch_code"
          :text="recipientInfo.branch_code"
          title="Branch"
          icon="mdi-bank"
        />
        <field-bank-name :recipientInfo="recipientInfo" v-if="recipientInfo.bank_name" />
        <field-account-number
            v-if="recipientInfo.account_number"
            :recipient-info="recipientInfo"
            label="Pay This Temporary Bank Account Number"
        />
        <textField
          :text="recipientInfo.address"
          title="Street Address"
          icon="mdi-map-marker"
        />
        <field-city :recipientInfo="recipientInfo" v-if="recipientInfo.city" />
        <textField
          :text="recipientInfo.state"
          title="State"
          icon="mdi-city"
        />
        <textField
          :text="recipientInfo.zipcode"
          title="Postal Code"
          icon="mdi-map-marker"
        />
        <textField
          :text="recipientInfo.country"
          title="Country of PB"
          icon="mdi-map-marker"
        />
        <field-phone :recipientInfo="recipientInfo" v-if="recipientInfo.phone" />
        <field-email :recipientInfo="recipientInfo" v-if="recipientInfo.email" />
    </div>
</template>

<script>
    import fieldName from './match-confirmed-reveal-field-name.vue';
    import fieldBankName from './match-confirmed-reveal-field-bank-name.vue';
    import fieldAccountNumber from './match-confirmed-reveal-field-account-number.vue';
    import fieldPhone from './match-confirmed-reveal-field-phone.vue';
    import fieldEmail from './match-confirmed-reveal-field-email.vue';
    import fieldCity from './match-confirmed-reveal-field-city.vue';
    import textField from './match-confirmed-reveal-text-field.vue';

    export default {
        components: {
            fieldName,
            fieldBankName,
            fieldAccountNumber,
            fieldPhone,
            fieldEmail,
            fieldCity,
            textField,
        },
        props: {
            recipientInfo: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
